<template>
  <div v-clipboard:copy="formatedCode" v-clipboard:success="onCopy" class="code-extract-component">
    <div
      v-if="highlight"
      v-highlightjs="{ language: highlight, code: formatedCode }"
      class="code font-monospace mr-2"
    />
    <div v-else class="code font-monospace mr-2" :class="{ 'code-checked': checked }">
      <!-- prettier-ignore -->
      <div
        v-for="(line, index) in formatedCodeLines"
        :key="index"
      ><span v-if="prompt" class="prompt font-monospace">{{ prompt }}&nbsp;</span>{{ line }}</div>
    </div>
    <div v-if="checked !== undefined" class="checked mr-1">
      <KmIcon
        color="success"
        :size="20"
        :style="{ opacity: checked ? 1 : 0 }"
        name="km-icon-check"
      />
    </div>
    <VIcon :size="12" class="mr-1 icon-copy">
      file_copy
    </VIcon>
  </div>
</template>

<script>
import KmIcon from '@/components/KmIcon'

export default {
  name: 'CodeExtract',

  components: {
    KmIcon,
  },

  props: {
    prompt: {
      type: String,
    },
    highlight: {
      type: String
    },
    code: {
      type: String,
    },
    checked: {
      type: Boolean,
      default: undefined,
    },
  },

  computed: {
    formatedCodeLines() {
      return this.formatedCode.split('\n').map(line => line + '\n')
    },
    formatedCode() {
      if (this.code) return this.code.trim()
      return this.$slots.default
        .map(node => node.text || '')
        .join('')
        .trim()
    },
  },

  methods: {
    onCopy: function(e) {
      this.$store.dispatch('DISPLAY_NOTIFICATION', {
        message: 'Successfully Copied to Clipboard',
        type: 'success',
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.code-extract-component {
  display: flex;
  background-color: var(--contrast);
  color: white;
  border-radius: 3px;
  &:hover {
    cursor:pointer;
    opacity: 0.8;
  }
}
.code {
  white-space: pre-wrap;
  flex: 1;

  &.code-checked {
    text-decoration: line-through;
    color: var(--success);
  }

  &.hljs {
    padding: 0;
    background: transparent;
  }
}
.prompt {
  user-select: none;
  opacity: 0.6;
}

.checked,
.copy {
  user-select: none;
  margin: -8px;
  padding: 8px;
  max-height: 37px;
  display: flex;
  align-items: center;
}

.copy {
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.4s;

  &:hover {
    opacity: 1;
  }
}
</style>
